import { type UUID } from '~/types/common';

import { newestFirst } from '~/utils';

import {
  type DeliveryNoteAdminWithRelatedData,
  type DeliveryNoteEvent,
} from '../types';

import { getEventFromAssetChain } from './getEventFromAssetChain';

type P = {
  assetChainsEnhanced: any; // TODO: Add proper type for lineItems
  lineItems: any; // TODO: Add proper type for lineItems
  users: DeliveryNoteAdminWithRelatedData['bulkUsers'];
};

/**
 * Extracts all events from the delivery note data, such as delivery note created, delivery arrived, delivery note signed, etc.
 * @param assetChainsEnhanced - The processed asset chains data
 * @param lineItems - The processed lineItems data
 * @param users - The users data
 * @returns A list of delivery note events
 */
export const getEvents = ({
  assetChainsEnhanced = [],
  lineItems,
  users = [],
}: P): DeliveryNoteEvent[] => {
  const getUser = (userId: UUID) => {
    return users.find(({ id }) => id === userId);
  };

  const events: DeliveryNoteEvent[] = [];

  for (const assetChainEnhanced of assetChainsEnhanced) {
    const assetChainEvent = getEventFromAssetChain({
      assetChainEnhanced,
      lineItems,
      getUser,
    });

    if (assetChainEvent) {
      events.push(assetChainEvent);
    }
  }

  const sortedEvents = newestFirst(events.filter(Boolean), 'timestamp');

  return sortedEvents;
};
